<footer class="footer">
        <p class="copyright">{{ 'company_name' | translate }}, Copyright &copy; {{ currentDate | date:'yyyy'}}
                <small [innerHTML]="'footer_text'|translate"></small>
        </p>
</footer>